import React from 'react';

import Chip from "@mui/joy/Chip";
import Link from "@mui/joy/Link";

// components
import CommonInfoTab from "../Common/CommonInfoTab";

// icons
import ApartmentIcon from '@mui/icons-material/Apartment';


class AccountCard extends React.Component {
    render() {
        if (this.props.mini){
            return (
                <Chip
                    startDecorator={<ApartmentIcon />}
                >
                    <Link
                        href={'/account/detail/'+this.props.account.id}
                        target={'_blank'}
                        fontSize={'small'}
                    >
                        {this.props.account.nameshort.length > 30?this.props.account.nameshort.slice(0, 30) + '...':this.props.account.nameshort}
                    </Link>
                </Chip>
            )
        }
        return(
            <CommonInfoTab
                groups={
                    [
                        {
                            title: this.props.account.nameshort,
                            icon: <ApartmentIcon/>,
                            linkPattern: '/account/detail/:linkParam',
                            linkParam: this.props.account.id,
                            flat: true,
                            fields: [
                                {
                                    title: 'Полное наименование',
                                    value: this.props.account.namelong,
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                },
                            ]
                        }
                    ]
                }
            />
        )
    }
}

export default AccountCard